import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { containerImageService } from '../services/workspaceAPI';
import { OkAction, ErrorAction } from './baseActions';
import { formatApiErrorPayload } from './utils';
import { selectCurrentWorkspaceId } from './utils/selectors';

type AppState = import('~/store').AppState;

export enum ContainerImageActionType {
  SILENT_GET_CONTAINER_IMAGES = 'SILENT_GET_CONTAINER_IMAGES',
  GET_CONTAINER_IMAGES = 'GET_CONTAINER_IMAGES',
  GET_CONTAINER_IMAGES_OK = 'GET_CONTAINER_IMAGES_OK',
  GET_CONTAINER_IMAGES_ERROR = 'GET_CONTAINER_IMAGES_ERROR',
}

type GetContainerImagesAction =
  | Action<ContainerImageActionType.SILENT_GET_CONTAINER_IMAGES>
  | Action<ContainerImageActionType.GET_CONTAINER_IMAGES>
  | OkAction<ContainerImageActionType.GET_CONTAINER_IMAGES_OK, RcInstanceDTO.ContainerImage[]>
  | ErrorAction<ContainerImageActionType.GET_CONTAINER_IMAGES_ERROR>;

export type ContainerImageAction = GetContainerImagesAction;

export const getImages =
  (): ThunkAction<void, AppState, null, GetContainerImagesAction> => async (dispatch, getState) => {
    if (getState().workspaceResources.containerImages.allIds.length > 0) {
      dispatch({ type: ContainerImageActionType.SILENT_GET_CONTAINER_IMAGES });
    } else {
      dispatch({ type: ContainerImageActionType.GET_CONTAINER_IMAGES });
    }

    const workspaceId = selectCurrentWorkspaceId(getState());
    const response = await containerImageService.getAll({ workspaceId });
    if (response.ok) {
      dispatch({
        type: ContainerImageActionType.GET_CONTAINER_IMAGES_OK,
        data: response.data as RcInstanceDTO.ContainerImage[],
      });
    } else {
      dispatch({
        ...formatApiErrorPayload(response),
        type: ContainerImageActionType.GET_CONTAINER_IMAGES_ERROR,
      });
    }
  };
